import styled from 'styled-components';
import { tablet768, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';
import { paddingBuilder } from 'styles/themeUtils';

const SectionRoot = styled(Section)`
  ${paddingBuilder.all(3, 1.5)}

  ${tablet768`
    ${paddingBuilder.all(4.5, 3.5, 6.5, 3.5)}
  `}

  ${desktop1440`
    ${paddingBuilder.all(6.5, 0, 8, 0)}

    & > * {
      ${paddingBuilder.all(0, 7)}
    }
  `}
`;

SectionRoot.defaultProps = {
  minHeight: '0px',
};

SectionRoot.displayName = 'SectionRoot';

export default SectionRoot;
